
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * 
 * 
 * 
 * 
 *                             ====  DO NOT EDIT THIS FILE  ====  
 * 
 * 
 * 
 *        This file is automatically generated.  Any direct changes to this file will be lost.
 * 
 * 
 * 
 * 
 * 
 * 
 * 
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */


_registerSassExport("site-themes", {
  "root": "",
  "PensionGold - Dark": "theme-pensiongold-dark",
  "PensionGold - Standard": "theme-pensiongold-standard"
});

_registerSassExport("third-party-themes", {
  "root": {
    "grid": "ag-theme-balham-dark",
    "html-editor": null
  },
  "PensionGold - Dark": {
    "grid": "ag-theme-balham-dark",
    "html-editor": "trumbowyg-dark"
  },
  "PensionGold - Standard": {
    "grid": "ag-theme-balham",
    "html-editor": null
  }
});

_registerSassExport("chart-themes", {
  "root": "rsDefault",
  "PensionGold - Dark": "rsDark",
  "PensionGold - Standard": "rsDefault"
});

_registerSassExport("hiddenCssClass", "display-none");

